import UISideNavItem from 'UIComponents/nav/UISideNavItem';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { SocialShareDropdown } from './SocialShareDropdown';
import { SocialShareList } from './SocialShareList';
import { MenuRow } from '../../cardMenu/components/MobileCardMenu';
import styled from 'academy-common-lib/utils/Styling';
import UIAccordionItem from 'UIComponents/accordion/UIAccordionItem';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const MobileSocialShareAccordion = styled(UIAccordionItem).withConfig({
  displayName: "SocialShareMenuOption__MobileSocialShareAccordion",
  componentId: "rvp2aj-0"
})(["[class^='UIAccordionItem__Indicator']{top:24px;left:16px;width:6px;}"]);
const SocialShareDropdownWrapper = styled.div.withConfig({
  displayName: "SocialShareMenuOption__SocialShareDropdownWrapper",
  componentId: "rvp2aj-1"
})(["margin-left:-12px;.uiDropdown__buttonLabel{padding-left:12px;margin-right:0;}"]);
export const MobileSocialShareMenuOption = ({
  onShare,
  item
}) => {
  return /*#__PURE__*/_jsx(SocialShareList, {
    item: item,
    onShare: onShare,
    renderList: (list, buttonText, isShareButton) => isShareButton ? list : /*#__PURE__*/_jsx(MobileSocialShareAccordion, {
      title: buttonText,
      children: /*#__PURE__*/_jsx(View, {
        as: "div",
        paddingBlockEnd: "500",
        children: list
      })
    }),
    renderRow: content => /*#__PURE__*/_jsx(MenuRow, {
      children: content
    }),
    shareButton: null // share button is present already on the card menu
  });
};
export const SocialShareMenuOption = ({
  onShare,
  item,
  shareButtonLabel = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.common.share"
  })
}) => {
  return /*#__PURE__*/_jsx(SocialShareDropdownWrapper, {
    children: /*#__PURE__*/_jsx(SocialShareDropdown, {
      initialAutoplacement: "horiz" // it is inside a menu already so we don't want to interfere with the menu's placement
      ,
      item: item,
      onShare: onShare,
      shareButton: /*#__PURE__*/_jsx(UISideNavItem, {
        iconRight: 'right',
        title: shareButtonLabel
      })
    })
  });
};
export default SocialShareMenuOption;